import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Check, Award, MapPin, Video, Search } from 'lucide-react';

const MyStory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showAssessmentMessage, setShowAssessmentMessage] = useState(false);

  // Check if user came from assessment completion
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const fromAssessment = params.get('from') === 'assessment';
    const assessmentCompleted = sessionStorage.getItem('glow_assessment_completed');
    
    if (fromAssessment || assessmentCompleted) {
      setShowAssessmentMessage(true);
    }
  }, [location]);

  const handleCheckEligibility = () => {
    navigate('/intake');
  };

  const credentials = [
    { icon: Award, text: 'Board Certified Physician Assistant' },
    { icon: Award, text: 'Master of Physician Assistant Studies, University of Nebraska Medical Center' },
    { icon: MapPin, text: 'Licensed in multiple states' },
    { icon: Video, text: 'Experience in telehealth and hormone care' },
    { icon: Search, text: 'Focus on root-cause hormone evaluation' }
  ];

  return (
    <div className="page-provider">
      <div className="provider-container">
        
        {/* Assessment Completion Message */}
        {showAssessmentMessage && (
          <div className="provider-assessment-notice" data-testid="assessment-notice">
            <p>
              Your responses suggest you may benefit from a clinical review. 
              The next step is a quick eligibility call with your provider.
            </p>
          </div>
        )}

        {/* Section Header */}
        <div className="provider-header">
          <h1 className="provider-section-title">Meet Your Provider</h1>
          <p className="provider-intro">
            You'll be cared for by a licensed medical professional specializing in 
            hormone optimization and women's metabolic health.
          </p>
        </div>

        {/* Two-Column Layout */}
        <div className="provider-content">
          {/* Left Column - Provider Image */}
          <div className="provider-image-column">
            <div className="provider-image-wrapper">
              <img 
                src="https://customer-assets.emergentagent.com/job_glow-health-funnel/artifacts/mkfku2ms_IMG_0428.jpeg"
                alt="Olakunle Ologun, MPAS, PA-C - Licensed Physician Assistant"
                className="provider-photo"
              />
            </div>
          </div>

          {/* Right Column - Provider Info */}
          <div className="provider-info-column">
            <div className="provider-name-block">
              <h2 className="provider-name">Olakunle Ologun, MPAS, PA-C</h2>
              <span className="provider-title">Licensed Physician Assistant</span>
            </div>

            <p className="provider-bio">
              Licensed Physician Assistant with clinical experience in emergency medicine, 
              primary care, telehealth, and hormone optimization. Specializes in hormone therapy, 
              metabolic health, weight management, fatigue, and personalized treatment plans 
              tailored to each patient's symptoms and labs.
            </p>

            {/* Credentials */}
            <div className="provider-credentials">
              <h3 className="credentials-title">Credentials & Expertise</h3>
              <ul className="credentials-list">
                {credentials.map((credential, index) => {
                  const IconComponent = credential.icon;
                  return (
                    <li key={index} className="credential-item">
                      <IconComponent size={18} className="credential-icon" />
                      <span>{credential.text}</span>
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* Trust Line */}
            <div className="provider-trust-block">
              <Check size={20} className="trust-check-icon" />
              <p className="provider-trust-line">
                Your care is never one-size-fits-all. Every plan is built around your labs, 
                symptoms, and goals.
              </p>
            </div>

            {/* CTA Section */}
            <div className="provider-cta-section">
              <button 
                onClick={handleCheckEligibility}
                className="btn-provider-cta"
                data-testid="check-eligibility-btn"
              >
                Check My Eligibility
              </button>
              <p className="provider-cta-subtext">
                Takes 2 minutes. Private. No commitment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyStory;
